import React, { useState, useCallback } from 'react';
import { Input } from 'antd';
import type { SearchProps } from 'antd/es/input';

const { Search } = Input;

export interface SearchBoxProps extends Omit<SearchProps, 'onSearch' | 'size'> {
  onSearch: (value: string) => void;
  onClear?: () => void;
  loading?: boolean;
  defaultValue?: string;
  className?: string;
  size?: 'small' | 'middle' | 'large';
  fullWidth?: boolean;
}

export const SearchBox: React.FC<SearchBoxProps> = ({
  placeholder = 'Search...',
  onSearch,
  onClear,
  loading = false,
  defaultValue = '',
  className = '',
  size = 'large',
  fullWidth = false,
  ...props
}) => {
  const [value, setValue] = useState(defaultValue);

  const handleSearch = useCallback((searchValue: string) => {
    onSearch(searchValue);
  }, [onSearch]);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);

    if (newValue === '' && onClear) {
      onClear();
    }
  }, [onClear]);

  return (
    <div className={fullWidth ? 'w-full' : ''}>
      <Search
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onSearch={handleSearch}
        loading={loading}
        size={size}
        allowClear
        className={className}
        enterButton="Search"
        {...props}
      />
    </div>
  );
};

export default SearchBox;
